const ForgotPassword = () => {
    return ( 
        <div>
            <h1>Forgot Password</h1>
        </div>
    );
}

export default ForgotPassword;
